module.exports = __webpack_public_path__ + "static/flags/SA-a1eb4d04965d3b15707998701069e18c.gif";